import { render, staticRenderFns } from "./HomeWallet.vue?vue&type=template&id=16a96f99&scoped=true"
import script from "./HomeWallet.vue?vue&type=script&lang=js"
export * from "./HomeWallet.vue?vue&type=script&lang=js"
import style0 from "./HomeWallet.vue?vue&type=style&index=0&id=16a96f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a96f99",
  null
  
)

export default component.exports